import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreateServiceSpecificationModel,
  DeleteServiceSpecificationModel,
  SearchServiceSpecificationModel,
} from '../../../models/service-specification.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class ServiceSpecificationService {
  private baseUrl = environment.baseUrl
  private resource = 'Servico'

  constructor(private httpClient: HttpClient) {}

  public createServiceSpecification(
    model: CreateServiceSpecificationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editServiceSpecification(
    model: any,
    // model: EditServiceSpecificationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteServiceSpecification(
    model: DeleteServiceSpecificationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedServiceSpecification(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listServiceSpecification(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public listServiceSpecificationByType(
    typeId: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/tipo-servico/${typeId}`,
    )
  }

  public getServiceSpecificationbyId(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedServiceSpecification(
    page: number,
    rows = 15,
    model: SearchServiceSpecificationModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
